module.exports = __webpack_public_path__ + "static/media/tickNewSkinny.1c7273eb.svg";